import { render, staticRenderFns } from "./announce-layout.vue?vue&type=template&id=4f626e4b&scoped=true&functional=true"
import script from "./announce-layout.vue?vue&type=script&lang=js"
export * from "./announce-layout.vue?vue&type=script&lang=js"
import style0 from "./announce-layout.vue?vue&type=style&index=0&id=4f626e4b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "4f626e4b",
  null
  
)

export default component.exports